import {Detention} from 'api-types/ffconnect';

export type LigneDetention = Detention['tolede']['commercialise_par'][number];

const hasVenteRecent = (ligne: LigneDetention): boolean =>
  ligne.poids_3_derniers_mois > 0;

export const getLignesDetentionAvecVente = (
  lignes: LigneDetention[],
): LigneDetention[] => lignes.filter(hasVenteRecent);

export const getNombreSocietesDetentionAvecVente = (
  lignes: LigneDetention[],
): number => getLignesDetentionAvecVente(lignes).length;
